export default "//yastatic.net/s3/distribution/pythia/frontend/_/6f57baa150ffd9846f164e8ead61253c.png";